import { LEGAL_PRIVACY_POLICY_HEADING } from './0-heading.md';
import { LEGAL_GENERAL_INFO } from './1-general-info.md';
import { LEGAL_GENERAL_AND_MANDATORY_INFO } from './2-mandatory-info.md';
import { LEGAL_DATA_COLLECTION } from './3-data-collection.md';
import { LEGAL_PROCESSING_OF_CUSTOMER_DATA } from './4-process-customer-data.md';
import { LEGAL_NEWSLETTER } from './5-newsletter.md';
import { LEGAL_COMMUNITY_ENGAGEMENT } from './6-community-engagement.md';
import { LEGAL_PLUGINS_AND_TOOLS } from './7-plugin-tools.md';
import { LEGAL_SOCIAL_LOGIN } from './8-social-login.md';
import { LEGAL_ANALYSIS_TOOL_AND_AD } from './9-analysis-tools-and-ad.md';
import { LEGAL_PAYMENT_PROCESSING } from './10-payment-processing.md';
import { LEGAL_CHANGES_TO_PRIVACY_POLICY } from './11-changes-to-privacy-policy.md';


/**------------------------------------------------------
 * Imprint Template
 */
export const LEGAL_PRIVACY_POLICY_TEMPLATE_DE: string = `
	<!-- let sectionIndex = 0; subSectionIndex = 0; -->
	${LEGAL_PRIVACY_POLICY_HEADING}
	${LEGAL_GENERAL_INFO}
	---
	${LEGAL_GENERAL_AND_MANDATORY_INFO}
	---
	${LEGAL_DATA_COLLECTION}
	---
	${LEGAL_PROCESSING_OF_CUSTOMER_DATA}
	---
	${LEGAL_NEWSLETTER}
	---
	<!-- if (engagement.community.discord || engagement.community.facebook) { -->
	${LEGAL_COMMUNITY_ENGAGEMENT}
	---
	<!-- } -->
	<!-- if (addons.plugins.youTube || addons.plugins.reCaptcha || addons.plugins.facebookChat) { -->
	${LEGAL_PLUGINS_AND_TOOLS}
	---
	<!-- } -->
	<!-- if (addons.socialLogin.facebook || addons.socialLogin.apple || addons.socialLogin.google) { -->
	${LEGAL_SOCIAL_LOGIN}
	---
	<!-- } -->
	<!-- if (addons.analytics.googleAnalytics || addons.analytics.facebookPixel) { -->
	${LEGAL_ANALYSIS_TOOL_AND_AD}
	---
	<!-- } -->
	<!-- if (payment.providers.paddle || payment.providers.stripe || payment.providers.paypal) { -->
	${LEGAL_PAYMENT_PROCESSING}
	---
	<!-- } -->
	${LEGAL_CHANGES_TO_PRIVACY_POLICY}
`;
